import { useState } from 'react';
import { useOutletContext } from 'react-router';
import { useNavigate } from 'react-router';
import Logo from '../../components/logo';
import config from '../../config';

const SignIn = () => {
  const { signIn } = useOutletContext();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleEnter = (e) => {
    if (e.key === 'Enter' && email && password) {
      signIn(email, password);
    }
  };

  const handleInputChange = (key) => (e) => {
    const value = String(e.target.value.trim());
    if (key === 'email') {
      setEmail(value);
    }
    if (key === 'password') {
      setPassword(value);
    }
  };

  return (
    <div
      className='flex flex-col items-center justify-between min-h-dvh relative'
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5)), url("https://static-resource.thechamps.app/img/login.png")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className='mt-4 flex items-center justify-between w-full px-6'>
        <div
          className='text-white text-2xl'
          onClick={() => navigate('/start')}
        >
          ‹
        </div>
        <Logo size='text-4xl' />
        <div></div>
      </div>
      <div className='p-6 w-full max-w-sm'>
        <h2 className='text-white text-5xl font-semibold mb-3'>Sign In</h2>
        <div className='mb-5 space-y-2'>
          <input
            type='email'
            placeholder='Email'
            onChange={handleInputChange('email')}
            value={email}
            className='w-full bg-white rounded-full py-2 px-4 '
          />
          <div className='relative'>
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder='Password'
              onChange={handleInputChange('password')}
              value={password}
              className='w-full bg-white rounded-full py-2 px-4 '
              onKeyUp={handleEnter}
            />
            <button
              onClick={() => setShowPassword(!showPassword)}
              className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-black transition-colors'
            >
              {showPassword ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth={1.5}
                  stroke='currentColor'
                  className='w-5 h-5'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z'
                  />
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z'
                  />
                </svg>
              ) : (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth={1.5}
                  stroke='currentColor'
                  className='w-5 h-5'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88'
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
        <button
          type='submit'
          className='w-full bg-yellow-500 py-3 rounded-full font-bold hover:bg-yellow-600 transition duration-200'
          onClick={() => signIn(email, password)}
        >
          Sign In
        </button>
        <p className='text-base text-white text-center mt-2'>
          Don't have an account?
          <a
            onClick={() => navigate('/signup')}
            className='text-white font-semibold underline ml-2'
          >
            Sign Up
          </a>
        </p>
        <div className='text-center mt-2'>
          <a
            onClick={() => navigate('/signin/reset-password')}
            className='text-white underline ml-2'
          >
            Forgot password?
          </a>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
